import { Grid, GridSize } from "@material-ui/core";
import React from "react";


export const Column: React.FC<{
  width: GridSize,
  className?: string,
  size?: string,
  style?: React.CSSProperties
  sm?: GridSize
}> = ({ width, ...props }) => (
  <Grid item xs={12} md={width} {...props}>
    {props.children}
  </Grid>
);

